import Footer from "./Footer";
import Hero from "./Hero";


function Body() {
  return (
    <div>
        <Hero />
        <br />
        <Footer />
    </div>
  );
}

export default Body;
